import React from "react";

export const LayerModal: React.FC<{
  open: boolean;
  title: string;
  subtitle?: string;
  onClose: () => void;
  children: React.ReactNode;
}> = ({ open, title, subtitle, onClose, children }) => {
  React.useEffect(() => {
    if (!open) return;

    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKeyDown);

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      window.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = prevOverflow;
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="layer-modal-backdrop"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className="layer-modal"
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        <div className="layer-modal-header">
          <div className="layer-modal-heading">
            {subtitle ? <div className="layer-modal-subtitle">{subtitle}</div> : null}
            <div className="layer-modal-title">{title}</div>
          </div>
          <button
            type="button"
            className="layer-modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>
        <div className="layer-modal-body">{children}</div>
      </div>
    </div>
  );
};


